export const languageToCountryMap: Record<string, string> = {
  EN: 'GB',
  PL: 'PL',
};
